import { Stack, Typography } from '@mui/material';
import { renderStatusMessage } from '../../../../pages/UserHistory/renderHelpers';
import { useTranslation } from 'react-i18next';

export const CardStatus = ({
  chargingStatus,
  text,
}: {
  chargingStatus: string;
  text: string;
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        gap: { xs: '5px' },
        backgroundColor: renderStatusMessage(chargingStatus).backgroundColor,
        padding: { xs: '4px 7px' },
        borderRadius: '6px',
        height: 'max-context',
        boxShadow: '0px 2px 4px 0px #00000040',
        // The badge is the short half of its row; it must not grow into the
        // date next to it.
        flexShrink: 0,
      }}
    >
      {renderStatusMessage(chargingStatus).icon}
      {/*
        i18next returns the key itself when a status has no translation, and a
        transactions list showed a badge reading
        "userHistoryPage.card.status.failure" — wide enough to squash the date
        beside it. The backend's status vocabulary grows (the Monobank webhook
        stores the bank's own strings), so falling back to the bare status is
        what keeps an unseen one from printing a dotted path across the row.
      */}
      <Typography variant="body1" noWrap>
        {t(`${text}.${chargingStatus}`, { defaultValue: chargingStatus })}
      </Typography>
    </Stack>
  );
};
